import {EditorState, Transaction} from "prosemirror-state";
import {EditorView} from "prosemirror-view";
import {NodeViewAdditionalParams} from "../common/createSetNodeAttributeCommand";



export const deleteImage = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: NodeViewAdditionalParams): boolean => {
    // Determine the position of the image node
    let pos = additionalParams && additionalParams.getPos ? additionalParams.getPos() : null;
    if (pos === null) {
        // Fallback to using the state's selection
        const { from, to } = state.selection;
        if (from !== to) {
            pos = from;
        } else {
            // No valid position found
            return false;
        }
    }

    // Create a transaction to delete the node
    const transaction = state.tr.delete(pos!, pos! + 1);

    if (dispatch) {
        // Dispatch the transaction if dispatch is provided
        dispatch(transaction);
    }
    return true;
}
